import { render, staticRenderFns } from "./description-page.vue?vue&type=template&id=0ef5e21b&scoped=true&"
import script from "./description-page.vue?vue&type=script&lang=js&"
export * from "./description-page.vue?vue&type=script&lang=js&"
import style0 from "./description-page.vue?vue&type=style&index=0&id=0ef5e21b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5e21b",
  null
  
)

export default component.exports